import React, {useRef}
	from "react"
import {FontAwesomeIcon}
	from "@fortawesome/react-fontawesome"
import {solid, regular}
	from "@fortawesome/fontawesome-svg-core/import.macro"
import {useSelector}
	from "react-redux"
import _
	from "lodash"
import Multiselect
	from "multiselect-react-dropdown"
import {Range}
	from "react-range"
import {isEmpty, revertStringDate}
	from "./../../common"
import {RootState}
	from "./../../globals"
import {SelectReact}
	from "../../components/select"
import
{
	OverlayTrigger,
	Tooltip
}
	from "react-bootstrap"

import "./../../components/dropdown/style.css"
import Constants from "../../constants"

/*
	Los espacios libres solo tienen sentido cuando NO se esta filtrando: con un
	filtro puesto, lo que se ve es un recorte y un "hueco libre" mentiria.
	(Esteban, 2026-09-21: se reescribe con los filtros nuevos.)
*/
export const unrestrictedResultsDisplay = (customSearch : any)=>
	!(customSearch.onlyPendingTuitions || customSearch.onlyPendingKits) &&
	/* "periods" es del diario (de varios) y "period" de la semanal (uno solo). */
	isEmpty(customSearch.periods) &&
	isEmpty(customSearch.period) &&
	isEmpty(customSearch.mentors) &&
	isEmpty(customSearch.courses) &&
	isEmpty(customSearch.buildings) &&
	isEmpty(customSearch.classrooms) &&
	(customSearch.attendanceState == null || customSearch.attendanceState === "todas")

const CalendarSideFilter = (props : any)=>
{
	const 
	{
		periods, courseRef, courses, buildings, mentors, buildingRef, searchChangeFn , customSearch, periodSearch,
		unrestrictedDisplay, availabilityDisplay, setAvailabilityDisplay, opcionesDelDia
	} = props

	/*
		Solo lo que tiene clase ESTE dia. La barra ofrecia todos los periodos,
		profesores, cursos y edificios del plantel aunque ese dia no hubiera ni uno.
		Si por lo que sea no llega la lista del dia, se cae a la lista completa.
		(Esteban, 2026-09-21)
	*/
	const esDiario = opcionesDelDia != null
	const delDia = opcionesDelDia || {}
	const periodosDelDia  = delDia.periodos  || periods
	const maestrosDelDia  = delDia.maestros  || mentors
	const cursosDelDia    = delDia.cursos    || courses
	const edificiosDelDia = delDia.edificios || buildings

	/* Las aulas se limitan a los edificios elegidos; sin edificio elegido, todas
	   las del dia. */
	const aulasDelDia = (delDia.aulas || []).filter
	(
		(aula : any) => (customSearch.buildings || []).length < 1
			|| (customSearch.buildings || []).some((edificio : any) => edificio && edificio.id === aula.buildingId)
	)

	const idleLocked : boolean = useSelector((state : RootState) => state.idleLockSwitch.value)
	let   courseSelRef         = useRef<Multiselect | null>(null)
	let   buildingSelRef       = useRef<Multiselect | null>(null)

	/* Antes cada barra era un arcoiris (verde, azul, amarillo, rojo) que no
	   decia nada: el color no cambiaba con lo que elegias. Lo util en un filtro
	   de rango es ver que tramo quedo seleccionado, asi que la barra va en gris
	   y el tramo elegido en naranja. */
	const rangeFilterRef : any=
	{
		capacity   : {label : "Capacidad", limit : 125},
		attendance : {label : "Asistencias", limit : 100},
		subsMin    : {label : "Ins/Min", limit : 125}
	}

	const pistaDelRango = (valores : number[], tope : number) =>
	{
		const desde = Math.max(0, Math.min(100, (valores[0] / tope) * 100))
		const hasta = Math.max(0, Math.min(100, (valores[1] / tope) * 100))

		return "linear-gradient(to right, var(--wa-filo) 0%, var(--wa-filo) " + desde + "%, " +
			"var(--wa-acento) " + desde + "%, var(--wa-acento) " + hasta + "%, " +
			"var(--wa-filo) " + hasta + "%, var(--wa-filo) 100%)"
	}

	const debtFilters : any[]=
	[
		{
			title     : "Saldos",
			parameter : "onlyPendingTuitions"
		},
		{
			title     : "Saldos kits",
			parameter : "onlyPendingKits"
		}
	]

	const rangeHandlesDisplay = (handleA : number, handleB : number, limit : number)=>
	{
		let andMore = limit + 1

		if(Math.abs(handleA - handleB) == andMore)
		{
			return "Mostrar todo"
		}
		else
		{
			if(handleA == handleB)
			{
				return handleA == andMore ? limit + "%^" : handleA + "%"
			}
			else
			{
				let arrangedData : any = [handleA, handleB].sort((a : number, b : number) => (a - b))

				return arrangedData[0] + " - " + (arrangedData[1] == andMore ? limit + "%^" : arrangedData[1] + "%")
			}
		}
	}

	const subTermsUpdate = (term : any, index : number, tags : any, listingField : string, subListingField : string)=>
	{
		let items = customSearch[listingField]

		items.splice(index, 1, {...term, [subListingField] : tags})

		searchChangeFn
		({
			target:
			{
				name  : listingField,
				value : items
			}
		})
	}

	return <div style={{minWidth : "342px", overflow : "auto", height : "calc(100vh - 149px)"}}>
		<div className="card card-default" style={{padding : "15px", marginTop : "40px", width : "325px"}}>
			<div style={{display : "flex", alignItems : "stretch"}}>
				<b style={{display : "inline-block", flex : 1, padding : "10px"}}>
					Filtros
				</b>
				<OverlayTrigger overlay=
				  {<Tooltip id="tooltip-activos">
					  Visibilidad de espacios libres:
					  &nbsp;
					  {
						!unrestrictedDisplay
							? "No disponible (Los parámetros de búsqueda personalizada no lo permiten)"
								: (availabilityDisplay ? "Habilitada" : "Deshabilitada")
					  }
				  </Tooltip>}
				>
					<div>
						<button
						  className="btn btn-default"
						  disabled={idleLocked || !unrestrictedDisplay}
						  onClick={() => setAvailabilityDisplay(!availabilityDisplay)}
						  /*
							Era un cuadro verde de rayas de 50x50 que parecia un error de
							dibujo: queria imitar los bloques de "Espacio Libre", pero suelto
							en la barra de filtros no se entendia. Ahora es un boton normal
							que se enciende cuando los espacios libres estan visibles.
							(Esteban, 2026-09-20)
						  */
						  style=
						  {{
							border       : "1.5px solid " + (availabilityDisplay && unrestrictedDisplay ? "var(--wa-acento)" : "var(--wa-filo-2)"),
							width        : "42px",
							height       : "42px",
							background   : availabilityDisplay && unrestrictedDisplay ? "var(--wa-acento-suave)" : "var(--wa-superficie)",
							color        : availabilityDisplay && unrestrictedDisplay ? "var(--wa-acento-hondo)" : "var(--wa-apagado)",
							borderRadius : "12px",
							padding      : "0px"
						  }}
						>
							<FontAwesomeIcon icon={availabilityDisplay && unrestrictedDisplay ? solid("eye") : solid("eye-slash")} />
						</button>
					</div>
				</OverlayTrigger>
			</div>
			<div>
				{/* Sin el marco negro global de fieldset (hasta en oscuro): los demas filtros (Saldos, Profesores) no lo llevan y la etiqueta quedaba encimada. (Esteban, 2026-10-22) */}
				<fieldset style={{border : "none", borderRadius : "0px", padding : "0px 0px 5px 0px", margin : "0px"}}>
					<legend>
						<label htmlFor="periodId" style={{position : "relative"}}>
							{esDiario ? "Periodos" : "Periodo"}
						</label>
					</legend>
					{/*
						En el diario: de varios, y solo el nombre. Las fechas del periodo ocupaban
						un renglon entero y en un calendario DIARIO no dicen nada. Van del mas
						viejo al mas nuevo. (Esteban, 2026-09-21)

						En la semanal sigue siendo uno solo: esa vista filtra por "period" y ademas
						usa sus fechas para marcar los dias fuera del periodo.
					*/}
					{
						esDiario
								?
							<Multiselect
							  displayValue="name"
							  disable={idleLocked}
							  options={periodosDelDia}
							  selectedValues={[...(customSearch.periods || [])]}
							  placeholder="Todos"
							  emptyRecordMsg="Ningún periodo tiene clase este día"
							  onSelect={(tags) => searchChangeFn({target : {name : "periods", value : tags}})}
							  onRemove={(tags) => searchChangeFn({target : {name : "periods", value : tags}})}
							/>
								:
							<>
								<SelectReact disabled={idleLocked} style={{height : "30px"}} name="period" id="period" onChange={periodSearch}
								  clearable={true} value={customSearch.period} className="btn btn-primary text-start" placeholder="Seleccione..."
								  children={periods}
								/>
								{
									isEmpty(customSearch.period) ? "" : <div style={{textAlign : "center", padding : "5px 5px 0px 5px"}}>
										{revertStringDate(customSearch.period.start)}
										&nbsp;
										-
										&nbsp;
										{revertStringDate(customSearch.period.end)}
									</div>
								}
							</>
					}
				</fieldset>
			</div>
			{
				debtFilters.map
				(
					(filter : any) => <div key={filter.parameter}>
						<label htmlFor="buildingIds" style={{position : "relative"}}>
							{filter.title}
						</label>
						<div style={{display : "flex"}}>{
							["Ver todo", "Pendientes"].map
							(
								(label : string, index : number)=>
								{
									const boolVal : boolean = index > 0
									const chosen  : boolean = customSearch[filter.parameter] == boolVal

									return <React.Fragment key={filter.parameter + index}>
										{!boolVal ? "" : <>&emsp;</>}
										{/*
											La opcion ELEGIDA va deshabilitada para que no se vuelva a
											pulsar, y Bootstrap pinta lo deshabilitado al 65% de opacidad:
											quedaba una caja de un naranja lavado con la letra encima sin
											leerse, sobre todo en oscuro. "Elegido" y "no se puede usar"
											no son lo mismo: aqui se devuelve la opacidad y va naranja
											lleno con letra blanca, que es lo que dice "este es".
											(Esteban lo reporto, 2026-09-20)
										*/}
										<button className={"btn " + (chosen ? "btn-primary" :  "btn-default")} type="button"
										  onClick={() => searchChangeFn({target : {name : filter.parameter, value : boolVal}})}
										  style=
										  {{
												border     : "1px solid var(--wa-acento)",
												width      : "50%",
												...(chosen
													? {background : "var(--wa-acento)", color : "#FFFFFF", opacity : 1}
													: {color : "var(--wa-acento)"})
										  }}
										  disabled={idleLocked || chosen}
										>
											{label}
										</button>
									</React.Fragment>
								}
							)
						}</div>
					</div>
				)
			}
			{/*
				"Capacidad" e "Ins/Min" eran dos barras de porcentaje que nadie movia, y
				"Asistencias" era otra barra de 0 a 100 que no contestaba lo que se
				pregunta de verdad. (Esteban, 2026-09-21)

				Solo en el calendario diario: en la vista semanal "ya pasaron / sin
				marcar" no quiere decir nada, porque la pregunta es de UN dia.
			*/}
			{!esDiario ? null : <>
			<div><label style={{position : "relative"}}>
				Asistencias
			</label></div>
			<div style={{display : "flex", gap : "6px", marginBottom : "10px"}}>{
				[
					{clave : "todas",  texto : "Todas"},
					{clave : "hechas", texto : "Ya pasaron"},
					{clave : "faltan", texto : "Sin marcar"}
				].map
				(
					(opcion : any)=>
					{
						const elegida : boolean = (customSearch.attendanceState || "todas") === opcion.clave

						return <button
						  key={opcion.clave}
						  type="button"
						  className={"btn " + (elegida ? "btn-primary" : "btn-default")}
						  disabled={idleLocked}
						  onClick={() => searchChangeFn({target : {name : "attendanceState", value : opcion.clave}})}
						  style=
						  {{
							border : "1px solid var(--wa-acento)",
							flex   : 1,
							...(elegida
								? {background : "var(--wa-acento)", color : "#FFFFFF", opacity : 1}
								: {color : "var(--wa-acento)"})
						  }}
						>
							{opcion.texto}
						</button>
					}
				)
			}</div>
			</>}
			<div><label htmlFor="buildingIds" style={{position : "relative"}}>
				Profesores
			</label></div>
			<Multiselect onSelect={(tags) => searchChangeFn({target : {name : "mentors", value : tags}})} displayValue="name"
			  options={maestrosDelDia} selectedValues={customSearch.mentors} emptyRecordMsg="No hay más opciones" disable={idleLocked}
			  onRemove={(tags) => searchChangeFn({target : {name : "mentors", value : tags}})} placeholder="Seleccione"
			/>
			<hr />
			<div><label htmlFor="buildingIds" style={{position : "relative"}}>
				Cursos
			</label></div>
			<div style={{padding : "0px 15px"}} className="nestedSelection">
				<Multiselect
				  options={cursosDelDia}
				  ref={courseSelRef}
				  displayValue="name"
				  disable={idleLocked}
				  placeholder="Seleccione..."
				  emptyRecordMsg="No hay más opciones"
				  selectedValues={[...customSearch.courses]}
				  onSelect={(courses) => searchChangeFn({target : {name : "courses", value : [...courses]}})}
				  onRemove={(courses) => searchChangeFn({target : {name : "courses", value : [...courses]}})}
				/>
			</div>
			{
				customSearch.courses.length < 1 ? "" : <>
					<hr />
					{
						customSearch.courses.map
						(
							(course : any, index : any) => <div key={"C_" + course.id} style={{padding : "5px 10px"}}>
								<div style=
								  {{
									background   : "var(--wa-papel-3)",
									borderRadius : "15px 15px 0px 0px"
								  }}
								><table style={{width : "100%"}}><tbody><tr>
									<td style={{padding : "8px 15px", width : "100%"}}>
										{course?.name}
									</td>
									<td>
										<button
										  className="btn btn-default"
										   disabled={idleLocked}
										  type="button"
										  onClick=
										  {
											()=>
											{
												let courses = customSearch.courses

												courses.splice(index, 1)

												if(courseSelRef && courseSelRef.current)
												{
													courseSelRef
														.current
														.resetSelectedValues()
														.then
														(
															()=>
															{
																searchChangeFn
																({
																	target:
																	{
																		name  : "courses",
																		value : courses
																	}
																})
															}
														)
												}
											}
										  }
										>
											<FontAwesomeIcon icon={solid("times")} />
										</button>
									</td>
								</tr></tbody></table></div>
								<fieldset style=
								  {{
									borderRadius : "0px 0px 15px 15px", padding :"0px 10px 10px", position : "relative",
									borderTop    : "unset"
								  }}
								>{
									courseRef["C_" + course.id].levels.length < 1
											?
										<div className="bg-info text-white"
										  style={{padding : "5px", borderRadius : "0px 0px 15px 15px"}}
										>
											<FontAwesomeIcon icon={solid("circle-info")} />
											&nbsp;
											El curso seleccionado no tiene ningún módulo asociado.
										</div>
											:
										<>
											<legend style={{paddingLeft : "15px", position : "absolute"}}>
												<label style={{position : "relative", paddingTop : "2px"}}>
													{Constants.Common.modules}
												</label>
											</legend>
											<div style={{paddingTop : "30px"}}>
												<Multiselect
												  displayValue="name"
												  disable={idleLocked}
												  selectedValues={[...course.levels]}
												  options={courseRef["C_" + course.id].levels}
												  emptyRecordMsg="No hay más opciones" placeholder="Especifique..."
												  onRemove={(levels : any) => subTermsUpdate(course, index, levels, "courses", "levels")}
												  onSelect={(levels : any) => subTermsUpdate(course, index, levels, "courses", "levels")}
												/>
											</div>
										</>
								}</fieldset>
							</div>
						)
					}
				</>
			}
			<hr />
			<div>
				<label
				  htmlFor="buildingIds"
				  style={{position : "relative"}}
				>
					Edificios
				</label>
			</div>
			<div style={{padding : "0px 15px"}} className="nestedSelection">
				<Multiselect
				  displayValue="name"
				  disable={idleLocked}
				  ref={buildingSelRef}
				  placeholder="Seleccione..." 
				  emptyRecordMsg="No hay más opciones"
				  options={edificiosDelDia} selectedValues={[...customSearch.buildings]}
				  onSelect={(tags) => {searchChangeFn({target : {name : "buildings", value : tags}})}}
				  onRemove={(tags)=>{searchChangeFn({target : {name : "buildings", value : tags}})}}
				/>
			</div>
			{/*
				Las aulas se limitan a los edificios elegidos; sin edificio elegido, todas
				las que tienen clase ese dia. Solo en el diario: la lista sale de las
				clases de ESE dia, asi que en la semanal saldria vacia. (Esteban, 2026-09-21)
			*/}
			{!esDiario ? null : <>
			<hr />
			<div>
				<label style={{position : "relative"}}>
					Aulas
				</label>
			</div>
			<div style={{padding : "0px 15px"}} className="nestedSelection">
				<Multiselect
				  displayValue="name"
				  disable={idleLocked}
				  options={aulasDelDia}
				  selectedValues={[...(customSearch.classrooms || [])]}
				  placeholder="Todas"
				  emptyRecordMsg="Ningún aula tiene clase este día"
				  onSelect={(tags) => searchChangeFn({target : {name : "classrooms", value : tags}})}
				  onRemove={(tags) => searchChangeFn({target : {name : "classrooms", value : tags}})}
				/>
			</div>
			</>}
			{
				customSearch.buildings.length < 1 ? "" : <>
					<hr />
					{
						customSearch.buildings.filter((building : any) => building).map
						(
							(building : any, index : any) => <div key={"B_" + building.id} style={{padding : "5px 10px"}}>
								<div style={{background : "var(--wa-papel-3)", borderRadius : "15px 15px 0px 0px"}}>
									<table style={{width : "100%"}}>
										<tbody>
											<tr>
												<td style={{padding : "8px 15px", width : "100%"}}>
													{building?.name}
												</td>
												<td>
													<button
													  className="btn btn-default"
													  disabled={idleLocked}
													  type="button"
													  onClick=
													  {
														()=>
														{
															let buildings = customSearch.buildings

															buildings.splice(index, 1)

															if(buildingSelRef && buildingSelRef.current)
															{
																buildingSelRef
																	.current
																	.resetSelectedValues()
																	.then
																	(
																		()=>
																		{
																			searchChangeFn
																			({
																				target:
																				{
																					name  : "buildings",
																					value : buildings
																				}
																			})
																		}
																	)
															}
														}
													  }
													>
														<FontAwesomeIcon icon={solid("times")} />
													</button>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
								<fieldset style=
								  {{
									borderTop    : "unset",
									borderRadius : "0px 0px 15px 15px",
									padding      :"0px 10px 10px",
									position     : "relative"
								  }}
								>{
									buildingRef["B_" + building.id].classrooms.length < 2
										?
									<div className="bg-info text-white"
									  style={{padding : "5px", borderRadius : "0px 0px 15px 15px"}}
									>
										<FontAwesomeIcon icon={solid("circle-info")} />
										&nbsp;
										El edificio seleccionado no tiene ningún aula asociada.
									</div>
										:
									<>
										<legend style={{paddingLeft : "15px", position : "absolute"}}>
											<label style={{position : "relative", paddingTop : "2px"}}>
												Aulas
											</label>
										</legend>
										<div style={{paddingTop : "30px"}}>
											<Multiselect
											  displayValue="name"
											  disable={idleLocked}
											  placeholder="Especifique..."
											  emptyRecordMsg="No hay más opciones"
											  selectedValues={building.classrooms}
											  options={[...buildingRef["B_" + building.id].classrooms]}
											  onRemove={(classrooms : any) => subTermsUpdate(building, index, classrooms, "buildings", "classrooms")}
											  onSelect={(classrooms : any) => subTermsUpdate(building, index, classrooms, "buildings", "classrooms")}
											/>
										</div>
									</>
								}</fieldset>
							</div>
						)
					}
				</>
			}
		</div>
	</div>
}

export default CalendarSideFilter
